import "./assets/scss/theme.scss";
import "./assets/css/custom.css";
import "./assets/scss/custom/custom.scss";
import "antd/dist/antd.css";

import {
  ACCESS_TOKEN_PASS,
  ACCESS_TOKEN_USER,
  GRANT_TYPE,
} from "constants/constants";
import React, { Component } from "react";
import { HashRouter as Router, Switch } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./routes/";
import { connect, useDispatch, useSelector } from "react-redux";

import AppRoute from "./routes/route";
import Confirm from "components/Custom/Confirm";
import HorizontalLayout from "./components/HorizontalLayout/";
import Loading from "components/Custom/LoadingOverlay";
import Message from "components/Custom/Message";
import NonAuthLayout from "./components/NonAuthLayout";
import PropTypes from "prop-types";
import VerticalLayout from "./components/VerticalLayout/";
import { baseUrl } from "./helpers/url_api_constant";
import { decryptData } from "helpers/cryptojs";
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { logout } from "store/actions";
import { postFormUrlencoded } from "helpers/api_helper";
import { getPermission } from "helpers/auth_helper";

// Import Routes

// layouts

// Import scss

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import fackbackend Configuration file

// Activating fake backend
fakeBackend();

// Activating fake firebase
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
    this.getAccessToken();
  }
  getAccessToken = async () => {
    // try {
    //     const params = new URLSearchParams();
    //     params.append("grant_type", GRANT_TYPE);
    //     params.append("password", ACCESS_TOKEN_PASS);
    //     params.append("UserName", ACCESS_TOKEN_USER);
    //     let accessToken = await postFormUrlencoded(`${baseUrl}/token`, params);
    //     localStorage.setItem("accessToken", JSON.stringify(accessToken));
    // } catch (error) {
    //     console.log(error);
    // }
    try {
      let authUser = decryptData(localStorage.getItem("authUser"))
      if (authUser == null) {
        this.props.logout();
      }

    } catch (e) { }
  };

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const permission = getPermission();
    // console.log(permission);
    const Layout = this.getLayout();
    return (
      <React.Fragment>
        <Message />
        <Loading />
        <Confirm />
        {/* <Router > */}
        <Switch>
          {" "}
          {publicRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}{" "}
          {authProtectedRoutes
            .filter((route, idx) => {

              if (permission) {

                if (route.path == "/dashboard" && permission.DHME != true) return false
                if (route.path == "/bi-dashboard" && permission.DBUI != true) return false

                if (route.path == "/booking-data" && permission.vBKD != true) return false
                if (route.path == "/booking-data/:pid/booking-data-detail" && permission.vBKD != true) return false

                if (route.path == "/nomination-week" && permission.vNMW != true) return false
                if (route.path == "/nomination-week/:pid/nomination-week-detail" && permission.vNMW != true) return false

                if (route.path == "/nomination-day" && permission.vNMD != true) return false
                if (route.path == "/nomination-day/:pid/nomination-day-detail" && permission.vNMD != true) return false

                if (route.path == "/metering-data-daily" && permission.vMTD != true) return false
                if (route.path == "/metering-data-daily/:pid/metering-data-daily-detail" && permission.vMTD != true) return false

                if (route.path == "/allocation-data" && permission.vALD != true) return false
                if (route.path == "/allocation-data/:pid/allocation-data-detail" && permission.vALD != true) return false

                if (route.path == "/metering-data-monthly" && permission.vMTM != true) return false
                if (route.path == "/metering-data-monthly/:pid/metering-data-monthly-detail" && permission.vMTM != true) return false

                if (route.path == "/quality-point-daily" && permission.vQPD != true) return false
                if (route.path == "/quality-point-daily/:date/:source/quality-point-daily-detail" && permission.vQPD != true) return false

                if (route.path == "/flow-selection" && permission.vFSN != true) return false
                if (route.path == "/flow-logic" && permission.vFLC != true) return false
                if (route.path == "/gas-volumn-line-pack" && permission.vGLP != true) return false
                if (route.path == "/flow-fuel-monthly-daily" && permission.vFFO != true) return false
                if (route.path == "/balancing-shinkgate-gas-data" && permission.vBSG != true) return false
                if (route.path == "/diesel-fuel-oil-data" && permission.vDFO != true) return false
                if (route.path == "/other-key-in-data" && permission.vOTH != true) return false
                if (route.path == "/gas-composition" && permission.vGAC != true) return false
                if (route.path == "/alarm-management" && permission.vALM != true) return false
                if (route.path == "/summary-report" && permission.vSRT != true) return false

                if (route.path == "/tpa-daily-report" && permission.vTPA != true) return false
                if (route.path == "/tpa-daily-report/:pid/tpa-daily-report-detail" && permission.vTPA != true) return false

                if (route.path == "/eod-summary-report" && permission.vEOD != true) return false
                if (route.path == "/tpa-balancing-and-overuse-report" && permission.vTBR != true) return false
                if (route.path == "/pipeline-utilization-report" && permission.vPUR != true) return false

                if (route.path == "/average-gas-delivery-report" && permission.vAGD != true) return false
                if (route.path == "/average-gas-delivery-report/:pid/:date/average-gas-delivery-report-detail" && permission.vAGD != true) return false

                if (route.path == "/gas-delivery-performance-report" && permission.vGDP != true) return false
                if (route.path == "/gas-delivery-performance-report/:year/gas-delivery-performance-report-detail" && permission.vGDP != true) return false

                if (route.path == "/delivery-gas-fuel-gas-report" && permission.vDGF != true) return false
                if (route.path == "/delivery-gas-fuel-gas-report/:pid/:date/delivery-gas-fuel-gas-report-detail" && permission.vDGF != true) return false
                
                if (route.path == "/shift-report" && permission.vSTR != true) return false
                if (route.path == "/shift-report/:pid/:date/shift-report-detail" && permission.vSTR != true) return false

                if (route.path == "/actual-supply-demand-actual-gsm" && permission.vASD != true) return false
                if (route.path == "/actual-supply-demand-actual-gsm/:date/actual-supply-demand-actual-gsm-detail" && permission.vASD != true) return false

                if (route.path == "/gas-composition-report" && permission.vGCN != true) return false
                if (route.path == "/gas-composition-report/:pid/gas-composition-report-detail" && permission.vGCN != true) return false

                if (route.path == "/user-management" && permission.vUSM != true) return false

                if (route.path == "/role-management" && permission.vRMN != true) return false
                if (route.path == "/role-management/:pid/role-management-detail" && permission.vRMN != true) return false

                if (route.path == "/shipper" && permission.vSHP != true) return false
                if (route.path == "/shipper/:pid/person" && permission.vSHP != true) return false
                
                if (route.path == "/meter" && permission.vMET != true) return false
                if (route.path == "/virtual-meter" && permission.vVMT != true) return false
                if (route.path == "/customer-type" && permission.vOTR != true) return false
                if (route.path == "/zone" && permission.vOTR != true) return false
                if (route.path == "/point" && permission.vOTR != true) return false
                if (route.path == "/region" && permission.vOTR != true) return false
                if (route.path == "/nomination" && permission.vOTR != true) return false
                if (route.path == "/area" && permission.vOTR != true) return false
                if (route.path == "/sub-area" && permission.vOTR != true) return false
                if (route.path == "/bv-zone" && permission.vOTR != true) return false
                if (route.path == "/block-valve" && permission.vOTR != true) return false
                if (route.path == "/industrial-estate" && permission.vOTR != true) return false
                if (route.path == "/quality-point" && permission.vOTR != true) return false
                if (route.path == "/remark1" && permission.vOTR != true) return false
                if (route.path == "/remark2" && permission.vOTR != true) return false
                if (route.path == "/remark3" && permission.vOTR != true) return false
                if (route.path == "/remark4" && permission.vOTR != true) return false
                if (route.path == "/remark5" && permission.vOTR != true) return false
                if (route.path == "/dashboard-url" && permission.vDUL != true) return false
                if (route.path == "/api-schedule-run" && permission.vAPI != true) return false
                if (route.path == "/api-parameter" && permission.vAPP != true) return false

                if (route.path == "/viewer-booking" && permission.vRVB != true) return false
                if (route.path == "/viewer-booking/:pid/viewer-booking-detail" && permission.vRVB != true) return false

                if (route.path == "/viewer-allocation" && permission.vRVA != true) return false 
                if (route.path == "/viewer-allocation/:pid/viewer-allocation-detail" && permission.vRVA != true) return false

                if (route.path == "/viewer-nomination-day" && permission.vRVN != true) return false
                if (route.path == "/viewer-nomination-day/:pid/viewer-nomination-day-detail" && permission.vRVN != true) return false

                if (route.path == "/viewer-metering-month" && permission.vRVM != true) return false
                if (route.path == "/viewer-metering-month/:pid/viewer-metering-month-detail" && permission.vRVM != true) return false
              }

              return true
            }
            )
            .map((route, idx) => {
              return (
                <AppRoute
                  path={route.path}
                  layout={Layout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                  exact
                />
              )
            }
            )
          }
          {" "}
        </Switch>{" "}
        {/* </Router>{" "}  */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

App.propTypes = {
  layout: PropTypes.object,
  logout: PropTypes.func,
};

export default connect(mapStateToProps, { logout })(App);
